import React from 'react';
import styles from './Cover.module.css';

const Cover = () => {
  return (
    <section className={styles.cover}> 
     <div style={{
      position: 'relative', 
      overflow: 'hidden', 
      margin: 0, 
      paddingBottom: '3em'
    }}>
      
      <video className={styles.video} autoPlay muted loop playsInline onError={(e) => console.error('Video error:', e)}>
        <source src="/intro-mobile.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div style={{
        position: 'absolute', 
        bottom: 0,  
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: 'white',
        padding: '2rem', 
        borderRadius: '1rem 1rem 0 0', 
        width: '70%', 
      }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}> 
          <img 
            src="/logo.png"  // Assuming logo.png is in the public folder
            alt="Logo"
            style={{ maxWidth: '30%' }} // Ensure logo scales down if needed
          />
        </div>

        <div style={{  
  position: 'relative', 
  overflow: 'visible' 
}}>
  <h2 style={{ 
    position: 'absolute', 
    bottom: '-1.5em', 
    left: '50%', 
    transform: 'translateX(-50%)', /* Center it properly */
    color: '#438B4D',
    fontSize: 28,
    fontWeight: 'semi-bold',
    textAlign: 'center',
    fontFamily: 'NewZen-Bold',
    whiteSpace: 'nowrap' /* Prevent the text from wrapping */
  }}> 
    More than dating
  </h2>
</div>

      </div>
    </div>
    </section>
  );
};
export default Cover;
